import GridViewIcon from "@mui/icons-material/GridView";
export const SeriesToolConfig = {
  name: "SERIES",
  tool: "SeriesToggle",
  icon: <GridViewIcon />,
};